import { Button } from '@acpaas-ui/react-components';
import { get } from 'lodash';
import { useParams } from 'react-router-dom';
import ManuallyAddedLegend from '../../../../../components/admin/ManuallyAddedLegend';
import { MODALS } from '../../../../../constants/modals.constants';
import { useLevelLoadError } from '../../../../../hooks/admin/useLevelLoadError.hook';
import { useLevelUnmount } from '../../../../../hooks/admin/useLevelUnmount.hook';
import { useSetBreadcrumbs } from '../../../../../hooks/admin/useSetBreadcrumbs.hook';
import { useModal } from '../../../../../hooks/useModal.hook';
import AddSchoolModal from '../../../../../modals/admin/AddSchoolModal';
import { ADMIN_SCHOOL_SCHOOLS_RESOURCE } from '../../../../../resources/admin/admin.school.schools.resource';
import { schools } from '../../../../../services/bff.api';
import ResourceTable from '../../../../core/ResourceTable';

const AdminSchoolSchools = () => {
  const params = useParams();
  const addSchoolModal = useModal(MODALS.ADD_SCHOOL_MODAL);
  const resource = {
    ...ADMIN_SCHOOL_SCHOOLS_RESOURCE,
    table: {
      ...ADMIN_SCHOOL_SCHOOLS_RESOURCE.table,
      dataTransform: (data) =>
        data?.map((i) => ({
          ...i,
          netId: params.netId,
          name: get(i, 'spoEntityData.shadow.name') || get(i, 'spoEntityData.agodi.name'),
          fullName: get(i, 'spoEntityData.shadow.fullName') || get(i, 'spoEntityData.agodi.fullName'),
          postcode: get(i, 'spoEntityData.shadow.postcode') || get(i, 'spoEntityData.agodi.postcode'),
          district: get(i, 'spoEntityData.shadow.district') || get(i, 'spoEntityData.agodi.district'),
          streetName: get(i, 'spoEntityData.shadow.street') || get(i, 'spoEntityData.agodi.street'),
          houseNumber: get(i, 'spoEntityData.shadow.houseNumber') || get(i, 'spoEntityData.agodi.houseNumber'),
          province: get(i, 'spoEntityData.shadow.province') || get(i, 'spoEntityData.agodi.province'),
          isManual: get(i, 'spoEntityMeta.isManual', false),
          managementId: params.managementId,
          communityId: params.communityId
        }))
    },
    api: {
      get: (urlConfig) => schools.getSchools(params.netId, params.managementId, params.communityId, urlConfig)
    }
  };

  useSetBreadcrumbs(ADMIN_SCHOOL_SCHOOLS_RESOURCE.key);
  useLevelLoadError(ADMIN_SCHOOL_SCHOOLS_RESOURCE.key);
  useLevelUnmount(ADMIN_SCHOOL_SCHOOLS_RESOURCE.key);

  return (
    <div className="spo-o-admin-school-management">
      <ManuallyAddedLegend className="u-margin-bottom-xs u-margin-top-md" />
      <ResourceTable
        resource={resource}
        actions={[
          <Button className="u-margin-right" iconRight="ai-add" size="small" onClick={addSchoolModal.onOpen}>
            School toevoegen
          </Button>
        ]}
      />
      <AddSchoolModal {...addSchoolModal} />
    </div>
  );
};

export default AdminSchoolSchools;
